import React, { useEffect, useRef } from "react";
import "../css/Sidebar.css";
import {
  clinicAtom,
  permissionAtom,
  pharmacyAtom,
} from "../../../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import { userRoleAtom } from "../../setup/atom/Atom";
import { useCurrentRole } from "../../../../_helper/constant/Permission";
import { patientsSidebarOptions, sidebarOptions } from "../constant/Constant";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import BottomBar from "./BottomBar";
import { cufrontLogos } from "../../../../cufront-assets/logos/Logos";
import CuPopup from "../../../../common_component/component/CuPopup";
import { Logout } from "../../../../_helper/constant/auth";
import { useState } from "react";
import SidebartemSmall from "./SidebartemSmall";
import { useLocation } from "react-router-dom";
import CuAvatar from "../../../../common_component/component/CuAvatar";
import "../css/Sidebar2.css";
import { cufrontIcons } from "../../../../cufront-assets/icons/Icons";
import { checkPermission } from "../../../../roles_and_permissions/_features";

const Sidebar = () => {
  const [selectedClinic, setSelectedClinic] = useAtom(clinicAtom);
  const [selectedPharmacy, setSelectedPharmacy] = useAtom(pharmacyAtom);
  const [userRole, setUserRole] = useAtom(userRoleAtom);
  const { bhp_registered_clinic, linked_pharmacy } = useCurrentRole();
  const [clinicToggle, setClinicToggle] = useState(false);
  const [permission] = useAtom(permissionAtom);
  const mainColorStyle = { backgroundColor: "var(--main-color)" };

  const clinicRef = useRef(null);

  // console.log("User Role", userRole);

  // console.log("Permission", permission);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // Extracting individual query parameters
  const step = queryParams.get("step");

  const [expanded, setExpanded] = useState(false);

  const lg = useMediaQuery({ query: "(min-width:1025px)" });

  // const { data: userData, isSuccess: userIsSuccess } = useUserFilter(
  //   `${ApiEndPoint.USERS}/${role_id}`,
  //   `?fields=id,first_name,last_name,role.*`,
  //   role_id ? true : false
  // );
  const userData = {};
  const userIsSuccess = false;

  const navigate = useNavigate();

  useEffect(() => {
    if (userIsSuccess) {
      setUserRole(userData);
    }
  }, [userIsSuccess]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isLogoImg =
        event.target.classList.contains("logo-img") ||
        event.target.parentElement.classList.contains("logo-img");

      if (clinicRef.current && !isLogoImg) {
        setClinicToggle(false);
      }
      if (event.target.classList.contains("more-icon")) {
        setClinicToggle(true);
      }
    };

    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const navigateHandler = (route) => {
    navigate(route);
    setExpanded(false);
  };

  const handleClinicSelect = (clinic) => {
    setSelectedClinic(clinic);
    localStorage.setItem("clinic", clinic?.id);
    setClinicToggle(false);
  };

  const handlePharmacySelect = (pharmacy) => {
    setSelectedPharmacy(pharmacy);
    localStorage.setItem("pharmacy", pharmacy?.id);
    setClinicToggle(false);
  };

  const toggleSidebarWidth = () => {
    setClinicToggle(false);
    setExpanded(!expanded);
  };

  const clinicData =
    (linked_pharmacy && linked_pharmacy.length > 0) ||
    !bhp_registered_clinic?.length
      ? linked_pharmacy
      : bhp_registered_clinic;

  const is_pharmacy = linked_pharmacy?.length > 0 ? true : false;

  const getItemName = (item) => {
    if (!item) return "";
    return item.pharmacy_name || item.clinic_name || "";
  };

  return lg ? (
    <div>
      <div
        onClick={toggleSidebarWidth}
        className={`sidebar ${expanded ? "cu-backdrop-2" : ""}`}
      ></div>
      <div className={`sidebar ${expanded ? "expanded" : ""}`}>
        <div className="sidebar-content">
          <div className="logo" onClick={() => setClinicToggle(!clinicToggle)}>
            {selectedClinic?.logo ? (
              <div className="w-[50px] rounded-full cursor-pointer">
                <img
                  src={selectedClinic?.logo}
                  alt="Company Logo"
                  className="logo-img"
                />
              </div>
            ) : (
              <div
                className="logo-img cursor-pointer w-[50px] h-[50px] border text-xl rounded-full flex justify-center items-center font-bold"
                style={mainColorStyle}
              >
                {is_pharmacy
                  ? selectedPharmacy?.pharmacy_name?.split("")[0]
                  : selectedClinic?.clinic_name?.split("")[0]}
              </div>
            )}
            {expanded && (
              <>
                <div className="flex flex-1  justify-between items-center">
                  <span className="sidebar-clinic-name">
                    {selectedClinic?.clinic_name?.toUpperCase()}
                  </span>
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => setClinicToggle(!clinicToggle)}
                    className="more-icon"
                  >
                    ⋮
                  </span>
                </div>
              </>
            )}
            {clinicToggle && (
              <div
                className={`clinic-div cu-clinic-div ${expanded && "expanded"}`}
                ref={clinicRef}
              >
                <ul className="py-1 text-sm text-gray-700">
                  {clinicData?.map((item) => {
                    console.log(item);
                    const itemName = getItemName(item);
                    const isPharmacy = item?.pharmacy_name ? true : false;
                    return (
                      <div
                        key={item?.id}
                        className="clinic-div-item"
                        onClick={() =>
                          isPharmacy
                            ? handlePharmacySelect(item)
                            : handleClinicSelect(item)
                        }
                      >
                        {item?.logo ? (
                          <div className="w-[50px] h-[50px] rounded-full overflow-hidden">
                            <img
                              src={item?.logo}
                              alt="logo"
                              className="w-full h-full"
                            />
                          </div>
                        ) : (
                          <div
                            className="w-[50px] h-[50px] border text-xl rounded-full flex justify-center items-center font-bold"
                            style={mainColorStyle}
                          >
                            {itemName?.charAt(0)}
                          </div>
                        )}
                        <li
                          className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${
                            item?.id === isPharmacy
                              ? selectedPharmacy?.id
                              : selectedClinic?.id
                                ? "text-black"
                                : ""
                          }`}
                        >
                          {itemName}
                        </li>
                      </div>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
          <div
            onClick={toggleSidebarWidth}
            className={`expand-icon ${expanded ? "expanded" : ""}`}
          >
            {/* <i
                onClick={toggleSidebarWidth}
                className={`fa-light fa-${expanded ? "less" : "greater"}-than`}
              ></i> */}

            <img
              style={{ marginLeft: "0px" }}
              src={
                expanded
                  ? cufrontIcons?.unexpandSidebar
                  : cufrontIcons?.expandSidebar
              }
            ></img>
          </div>

          <div id="icons">
            <div className="sidebar-middle-mini">
              {(userRole?.role?.name === "Patient"
                ? patientsSidebarOptions
                : sidebarOptions
              ).map((option, index) => {
                // console.log("Option", option);
                if (
                  checkPermission(
                    permission?.allowed_features,
                    option?.featureId
                  )
                ) {
                  return (
                    <div className="extra-content" key={option?.id}>
                      <SidebartemSmall
                        name={option.name}
                        activeIcon={option.activeIcon}
                        inactiveIcon={option.inactiveIcon}
                        className={"sidebar-link-small"}
                        route={option.route}
                        key={option.id}
                        onClick={() => navigateHandler(option.route)}
                        expanded={expanded}
                      />

                      {expanded && (
                        <span
                          onClick={() => navigateHandler(option.route)}
                          className={`${
                            location.pathname === option.route
                              ? "sidebar-text-active"
                              : "sidebar-text"
                          }`}
                          style={{
                            marginInlineStart: "12px",
                          }}
                        >
                          {option?.name}
                        </span>
                      )}
                    </div>
                  );
                }
              })}
            </div>
          </div>
          <div className="user">
            <div className={`sidebar-dr-details-mini ${expanded ? "gap" : ""}`}>
              {expanded && (
                <>
                  <CuAvatar name={`${userRole?.first_name?.[0] ?? ""}`} />

                  <div className="sidebar-dr-prf">
                    <span className="sidebar-dr-name">{`${userRole?.first_name} ${userRole?.last_name}`}</span>
                    {/* <span className="sidebar-dr-type">MBBS</span> */}
                  </div>
                </>
              )}
              {/* */}
              <CuPopup
                trigger={
                  expanded ? (
                    <span>⋮</span>
                  ) : (
                    <div className="cursor-pointer">
                      <CuAvatar name={`${userRole?.first_name?.[0] ?? ""}`} />
                    </div>
                  )
                }
                position="custom"
                closeOnDocumentClick
                customPosition={{
                  left: "132px",
                  bottom: "0px",
                  transform: " translateX(-50%)",
                }}
                animation="fade"
              >
                <div style={{ width: "120px" }}>
                  <ul
                    style={{ listStyleType: "none" }}
                    className="cursor-pointer"
                  >
                    <li
                      onClick={() => {
                        navigate("/new/clinicshow");
                      }}
                      className="hover:font-bold"
                    >
                      Tv View
                    </li>
                    <li
                      onClick={() => {
                        navigate("/new/editprofile");
                      }}
                      className="hover:font-bold"
                    >
                      Edit Profile
                    </li>
                    <li
                      onClick={() => {
                        navigate("/new/mynotes");
                      }}
                      className="hover:font-bold"
                    >
                      My Notes
                    </li>
                    <li
                      onClick={() => {
                        Logout();
                        navigate("/login");
                      }}
                      className="hover:font-bold"
                    >
                      Log Out
                    </li>
                  </ul>
                </div>
              </CuPopup>
            </div>
          </div>
        </div>

        <div className="copmany-logo">
          {expanded ? (
            <div className="sidebar-cufront-logo">
              <img src={cufrontLogos.cufrontLogo} />
              <span className="sidebar-copyright">All rights reserved</span>
            </div>
          ) : (
            <div className="sidebar-cufront-logo2">
              <img src={cufrontLogos.cufrontLogomark2} />
              <span className="sidebar-copyright">All rights reserved</span>
            </div>
          )}
        </div>
      </div>
    </div>
  ) : (
    !step && <BottomBar />
  );
};

export default Sidebar;
